var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamaraAgregar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5446_111581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 26.6667C22.7614 26.6667 25 24.4281 25 21.6667C25 18.9052 22.7614 16.6667 20 16.6667C17.2386 16.6667 15 18.9052 15 21.6667C15 24.4281 17.2386 26.6667 20 26.6667Z",
    stroke: "#D9D9D9",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 6.66666H16.6667C16.2246 6.66666 15.8007 6.84225 15.4882 7.15481C15.1756 7.46737 15 7.8913 15 8.33332C15 9.21738 14.6488 10.0652 14.0237 10.6903C13.3986 11.3155 12.5507 11.6667 11.6667 11.6667H8.33333C7.44928 11.6667 6.60143 12.0178 5.97631 12.643C5.35119 13.2681 5 14.1159 5 15V30C5 30.884 5.35119 31.7319 5.97631 32.357C6.60143 32.9821 7.44928 33.3333 8.33333 33.3333H31.6667C32.5507 33.3333 33.3986 32.9821 34.0237 32.357C34.6488 31.7319 35 30.884 35 30V18.3333",
    stroke: "#D9D9D9",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 10H35",
    stroke: "#D9D9D9",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 5V15",
    stroke: "#D9D9D9",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5446_111581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamaraAgregar);
export default __webpack_public_path__ + "static/media/camara-agregar.ebe82eb4fec950578add546db0df6e07.svg";
export { ForwardRef as ReactComponent };